import DiplomaWorksCatalogPage from "./DiplomaWorksCatalogPage";

export default DiplomaWorksCatalogPage;